export default __webpack_public_path__ + "static/media/Acumin-RPro.0ff8c5d6.otf";